import { render, staticRenderFns } from "./CapitalImobilizadoCirculantePercentual.vue?vue&type=template&id=3746ea1a&scoped=true&"
import script from "./CapitalImobilizadoCirculantePercentual.vue?vue&type=script&lang=js&"
export * from "./CapitalImobilizadoCirculantePercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746ea1a",
  null
  
)

export default component.exports